export type ValueFormatter = (value: number, localeCode: string, currencyCode?: string) => string;

export enum MetricType {
  IMPRESSIONS = 'IMPRESSIONS',
  FRAMES = 'FRAMES',
  SOT = 'SOT',
  PRICE_GROSS = 'PRICE_GROSS',
  PRICE_INDEXED = 'PRICE_INDEXED',
  // REPETITIONS = 'REPETITIONS',
  DELIVERED_IMPRESSIONS = 'DELIVERED_IMPRESSIONS',
  DELIVERED_SOT = 'DELIVERED_SOT',
  // DELIVERED_PRICE_GROSS = 'DELIVERED_PRICE_GROSS',
  // DELIVERED_PRICE_INDEXED = 'DELIVERED_PRICE_INDEXED',
  DELIVERED_PLAYS = 'DELIVERED_PLAYS',
}

export interface MetricOption {
  name: string;
  code: MetricType;
}
